import Button from '@shared/components/Button/Button';

import { ReactComponent as ArrowDown } from 'assets/icons/ArrowDown.svg';
import { getDefaultRoleTranslation } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';

import RoleSettingsSection from './RoleSettingsSection';
import useRoleChange from '../MembersSection/useRoleChange';
import useWorkspaceMembers from '../useWorkspaceMembers';
import { getDefaultMemberRoleName } from '../utils';

interface SelectedMemberSettingsProps {
  memberId: string;
  onClose: () => void;
}

const SelectedMemberSettings = ({ memberId, onClose }: SelectedMemberSettingsProps) => {
  const changeRole = useRoleChange();
  const members = useWorkspaceMembers();

  const member = members.find(({ id }) => id === memberId);
  const roleNameWithFallback =
    getDefaultRoleTranslation(member?.defaultRoleType, member?.roleName || '') ||
    member?.roleName ||
    getDefaultMemberRoleName({ userId: memberId });
  const displayName = member?.name || member?.email || member?.phone || memberId;

  return (
    <div className="flex flex-col space-y-6">
      <div className="text-black flex cursor-pointer select-none items-center space-x-2" onClick={onClose}>
        <Button variant="buttonIconGhost" size="neutral" className="rounded-xl p-1.5">
          <ArrowDown className="h-5 w-5 shrink-0 stroke-1.5 stroke-current rotate-90" />
        </Button>
        <h5 className="font-semibold" translate="no">
          {displayName}
        </h5>
      </div>
      <RoleSettingsSection
        roleId={member?.roleId}
        roleName={roleNameWithFallback}
        onRoleChange={(roleId) => member && changeRole(member.id, roleId)}
      />
    </div>
  );
};

export default SelectedMemberSettings;
